export default __webpack_public_path__ + "static/media/msg-ico.cc616f81.svg";